import { useNavigate } from 'react-router-dom'
import EditableListPage from '../components/EditableListPage'
import TableView from '../../shared/components/TableView'
import { useTranslation } from 'react-i18next'

const NewsletterSubscriptions = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderTable = items => {
        const columns = [
            { key: 'email', label: t('fields.subscribers.email') },
            { key: 'subscribed_at', label: t('fields.subscribers.subscribed_at') },
            { key: 'unsubscribed_at', label: t('fields.subscribers.unsubscribed_at') },
        ]

        const handleRowClick = item => {
            navigate(`/admin/auth/newsletter-subscribers/${item.id}`)
        }

        return (
            <TableView
                data={items}
                columns={columns}
                // onRowClick={handleRowClick}
                searchKeys={['email']}
                searchPlaceholder={t('search.email')}
            />
        )
    }

    return (
        <EditableListPage
            title={t('navigation_admin.newsletter.subscriptions')}
            endpoint='admin/newsletter-subscribers'
            renderTable={renderTable}
            view='table'
            rowLink='/admin/auth/newsletter-subscribers'
            exportEnabled
            // buttons={
            //     <Button size='medium' onClick={() => navigate('/admin/auth/newsletter-subscribers/create')}>
            //         <FaPen /> Create volunteer data
            //     </Button>
            // }
        />
    )
}

export default NewsletterSubscriptions
